import gql from 'graphql-tag';

export default gql`
  mutation UnlinkActivityMutation($activityId: Int!) {
    dailyTracker {
      unlinkActivity(activityId: $activityId) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          authCode: code
        }
      }
    }
  }
`;
